import React, { useEffect, useRef, useState } from 'react';
import "./MovieCarouselComponent.css"
import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
import '@glidejs/glide/dist/css/glide.theme.min.css';
import { Link } from "react-router-dom";

const MovieCarouselComponent = () => {
  const [images, setImages] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState('');

  useEffect(() => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        client_token: "ebd86470-7e90-4ece-9e89-1b6d4d2cbb61",
      },
    };

    fetch(`${process.env.REACT_APP_DEV_BASE_URL}/v1/movie/online?countryId=1&eventType=0`, requestOptions)
      .then((response) => response.json())
      .then((MovieList) => {
        const fetchedMovieInfo = MovieList.data.movies.map((moviedata) => moviedata);
        const fetchedImages = MovieList.data.movies.map((moviedata) => moviedata.thumbnail);
        setImages(fetchedImages);
        if (fetchedImages.length > 0) {
          setBackgroundImage(fetchedImages[0]);
          console.log(fetchedMovieInfo)
        }
      })
      .catch((error) => console.error('Error fetching movies:', error));
  }, []);

  const glideRef = useRef(null);
  const glideIndex = useRef(null);

  useEffect(() => {
    if (images.length > 0) {
      const glide = new Glide(glideRef.current, {
        type: 'carousel',
        hoverpause: false,
        startAt: 0,
        perView: 5,
        autoplay: 3000, // Autoplay interval in milliseconds
      });

      glide.on('move.after', () => {
        const currentIndex = glide.index;
        setBackgroundImage(images[currentIndex]);
        glideIndex.current = currentIndex
      });

      glide.mount();

      return () => glide.destroy(); // Cleanup on unmount
    }
  }, [images]);

  return (
    <div
      className="carousel-container"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div ref={glideRef} className="glide">
        <div className="glide__track" data-glide-el="track">
          <ul className="glide__slides ">
            {images.map((image, index) => (
              <li key={index} className="glide__slide">
                <img className='slide_Image' src={image} alt={`Slide ${index + 1}`} />
                <button className='movieMoreInfoBtn'>Now Showing</button>
              </li>
            ))}
          </ul>
        </div>
        
        {/* <button className='viewMoreMoviesBtn'>View More</button> */}
        <Link to="/movies" className='viewMoreMoviesBtn'>View More</Link>
      </div>
    </div>
  );
};

export default MovieCarouselComponent;
